export { default } from './SearchInput';
export type { SearchInputProps } from './SearchInput';
